/* ===== AUSSENBORDER24 – NEWSLETTER SIGNUP ===== */

(function () {
  'use strict';

  var SELECTOR_FORM = '.js-footer-newsletter-form';
  var SELECTOR_FEEDBACK = '[data-newsletter-feedback]';

  var STORAGE = {
    pendingKey: 'a24NewsletterPending',
    resultKey: 'a24NewsletterResult',
    stateVersionKey: 'a24NewsletterStateVersion',
    stateVersion: '4'
  };

  var savedResultHandled = false;

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (_err) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
      return true;
    } catch (_err) {
      return false;
    }
  }

  function storageRemove(key) {
    try {
      sessionStorage.removeItem(key);
      return true;
    } catch (_err) {
      return false;
    }
  }

  function ensureStorageVersion() {
    var storedVersion = storageGet(STORAGE.stateVersionKey);
    if (storedVersion === STORAGE.stateVersion) return;

    storageRemove(STORAGE.pendingKey);
    storageRemove(STORAGE.resultKey);
    storageSet(STORAGE.stateVersionKey, STORAGE.stateVersion);
  }

  function sanitizeFormAction(form) {
    if (!form) return;

    if (form.hasAttribute('target')) {
      form.removeAttribute('target');
    }

    var actionAttr = form.getAttribute('action') || '/contact';
    form.setAttribute('action', actionAttr.split('#')[0] || '/contact');

    var legacyFrame = document.getElementById('a24-newsletter-target');
    if (legacyFrame && legacyFrame.parentNode) {
      legacyFrame.parentNode.removeChild(legacyFrame);
    }
  }

  function isHomepage() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function hasPostedSignal() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get('form_type') === 'customer' ||
        params.get('contact_posted') === 'true' ||
        params.get('customer_posted') === 'true';
    } catch (_err) {
      return false;
    }
  }

  function isPendingSubmit() {
    return storageGet(STORAGE.pendingKey) === '1';
  }

  function markPendingSubmit() {
    storageSet(STORAGE.pendingKey, '1');
  }

  function clearPendingSubmit() {
    storageRemove(STORAGE.pendingKey);
  }

  function saveResult(result) {
    if (!result) return;
    storageSet(STORAGE.resultKey, JSON.stringify(result));
  }

  function consumeSavedResult() {
    var raw = storageGet(STORAGE.resultKey);
    if (!raw) return null;

    storageRemove(STORAGE.resultKey);

    try {
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.type || !parsed.message) return null;
      return parsed;
    } catch (_err) {
      return null;
    }
  }

  function getModalEls() {
    var overlay = document.getElementById('a24-newsletter-result-overlay');
    var dialog = document.getElementById('a24-newsletter-result-dialog');

    if (overlay && dialog) {
      return {
        overlay: overlay,
        dialog: dialog,
        title: dialog.querySelector('[data-newsletter-modal-title]'),
        body: dialog.querySelector('[data-newsletter-modal-body]'),
        close: dialog.querySelector('[data-newsletter-modal-close]')
      };
    }

    overlay = document.createElement('div');
    overlay.id = 'a24-newsletter-result-overlay';
    overlay.style.position = 'fixed';
    overlay.style.inset = '0';
    overlay.style.background = 'rgba(0,0,0,0.45)';
    overlay.style.zIndex = '9998';
    overlay.style.display = 'none';

    dialog = document.createElement('div');
    dialog.id = 'a24-newsletter-result-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'a24-newsletter-result-title');
    dialog.style.position = 'fixed';
    dialog.style.left = '50%';
    dialog.style.top = '50%';
    dialog.style.transform = 'translate(-50%, -50%)';
    dialog.style.width = 'min(92vw, 520px)';
    dialog.style.background = '#ffffff';
    dialog.style.borderRadius = '12px';
    dialog.style.boxShadow = '0 20px 40px rgba(0,0,0,.25)';
    dialog.style.padding = '22px';
    dialog.style.zIndex = '9999';
    dialog.style.display = 'none';

    dialog.innerHTML =
      '<p style="margin:0 0 8px;font-size:.73rem;letter-spacing:.08em;text-transform:uppercase;color:#2563eb;font-weight:700;">aussenborder24.de</p>' +
      '<h3 id="a24-newsletter-result-title" data-newsletter-modal-title style="margin:0 0 10px;font-size:1.2rem;color:#111827;line-height:1.25;">Newsletter</h3>' +
      '<p data-newsletter-modal-body style="margin:0 0 16px;color:#374151;line-height:1.55;white-space:pre-line;"></p>' +
      '<div style="display:flex;justify-content:flex-end;">' +
      '<button type="button" data-newsletter-modal-close style="padding:9px 14px;border:0;border-radius:8px;background:#2563eb;color:#fff;font-weight:700;cursor:pointer;">Verstanden</button>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(dialog);

    var closeModal = function () {
      overlay.style.display = 'none';
      dialog.style.display = 'none';
    };

    overlay.addEventListener('click', closeModal);

    var closeBtn = dialog.querySelector('[data-newsletter-modal-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog.style.display === 'block') {
        closeModal();
      }
    });

    return {
      overlay: overlay,
      dialog: dialog,
      title: dialog.querySelector('[data-newsletter-modal-title]'),
      body: dialog.querySelector('[data-newsletter-modal-body]'),
      close: closeBtn
    };
  }

  function showResultModal(type, message) {
    if (!message) return;

    var modal = getModalEls();
    if (!modal || !modal.title || !modal.body) return;

    if (type === 'success') {
      modal.title.textContent = 'Newsletter erfolgreich';
      if (message === 'Vielen Dank. Ihre E-Mail wurde erfolgreich für den Newsletter eingetragen.') {
        message = 'Vielen Dank für Ihre Anmeldung zur aussenborder24.de Mailingliste.\n\nSie erhalten künftig Angebote, Neuheiten und praxisnahe Tipps.\nAbmeldung jederzeit über den Link in jeder E-Mail.';
      }
      modal.dialog.style.borderTop = '6px solid #16a34a';
    } else if (type === 'error') {
      modal.title.textContent = 'Newsletter fehlgeschlagen';
      modal.dialog.style.borderTop = '6px solid #dc2626';
    } else {
      modal.title.textContent = 'Newsletter Hinweis';
      modal.dialog.style.borderTop = '6px solid #2563eb';
    }

    modal.body.textContent = message;
    modal.overlay.style.display = 'block';
    modal.dialog.style.display = 'block';

    if (modal.close) {
      modal.close.focus();
    }
  }

  function readRenderedFeedback(form) {
    var fallbackSuccess = 'Vielen Dank für Ihre Anmeldung zur aussenborder24.de Mailingliste.\n\nSie erhalten künftig Angebote, Neuheiten und praxisnahe Tipps.\nAbmeldung jederzeit über den Link in jeder E-Mail.';
    var fallbackError = 'Die Anmeldung konnte gerade nicht abgeschlossen werden. Bitte versuchen Sie es erneut.';

    if (!form) return null;

    var feedbackEl = form.querySelector(SELECTOR_FEEDBACK);
    if (!feedbackEl) return null;

    var successNode = feedbackEl.querySelector('[data-newsletter-status="success"]');
    if (successNode) {
      var successText = String(successNode.textContent || '').replace(/\s+/g, ' ').trim();
      return { type: 'success', message: successText || fallbackSuccess };
    }

    var errorNode = feedbackEl.querySelector('[data-newsletter-status="error"]') ||
      feedbackEl.querySelector('.errors') ||
      feedbackEl.querySelector('.form__message--error');
    if (errorNode) {
      var errorText = String(errorNode.textContent || '').replace(/\s+/g, ' ').trim();
      return { type: 'error', message: errorText || fallbackError };
    }

    return null;
  }

  function setSubmitButtonState(submitBtn, text, disabled) {
    if (!submitBtn) return;
    submitBtn.disabled = disabled;
    submitBtn.textContent = text;
  }

  function cleanContactHash() {
    try {
      if (window.location.hash === '#contact_form') {
        history.replaceState(null, document.title, window.location.pathname + window.location.search);
      }
    } catch (_err) {
      /* ignore */
    }
  }

  function bindForm(form) {
    if (!form || form.dataset.a24NewsletterBound === '1') return;
    form.dataset.a24NewsletterBound = '1';

    sanitizeFormAction(form);

    var submitBtn = form.querySelector('button[type="submit"]');
    var defaultBtnText = submitBtn ? submitBtn.textContent : 'Anmelden';

    function setIdle() {
      setSubmitButtonState(submitBtn, defaultBtnText, false);
    }

    function setBusy() {
      setSubmitButtonState(submitBtn, 'Wird angemeldet...', true);
    }

    if (isHomepage() && !savedResultHandled) {
      var savedResult = consumeSavedResult();
      if (savedResult) {
        showResultModal(savedResult.type, savedResult.message);
        clearPendingSubmit();
        setIdle();
      }
      savedResultHandled = true;
    }

    var renderedFeedback = readRenderedFeedback(form);
    var shouldHandleRenderedFeedback = !!renderedFeedback && (hasPostedSignal() || isPendingSubmit());
    if (shouldHandleRenderedFeedback) {
      if (isHomepage()) {
        showResultModal(renderedFeedback.type, renderedFeedback.message);
      } else {
        saveResult(renderedFeedback);
        clearPendingSubmit();
        setIdle();
        if (window.A24Theme?.shouldProtectEditorClicks?.()) return;

        window.location.assign('/');
        return;
      }

      clearPendingSubmit();
      setIdle();
    } else if (isPendingSubmit()) {
      // No rendered server feedback: clear stale pending state.
      clearPendingSubmit();
      setIdle();
    }

    cleanContactHash();

    var newsletterSubmitting = false;

    form.addEventListener('submit', function (event) {
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
        event.preventDefault();
        newsletterSubmitting = false;
        clearPendingSubmit();
        setIdle();
        return;
      }

      newsletterSubmitting = true;
    });

    window.addEventListener('beforeunload', function () {
      if (newsletterSubmitting) {
        setBusy();
        markPendingSubmit();
      }
    });

    window.addEventListener('pageshow', function () {
      newsletterSubmitting = false;
      setIdle();
    });
  }

  function init(scope) {
    ensureStorageVersion();

    var root = scope && scope.querySelectorAll ? scope : document;
    var forms = root.querySelectorAll(SELECTOR_FORM);

    if (root.matches && root.matches(SELECTOR_FORM)) {
      bindForm(root);
    }

    Array.prototype.forEach.call(forms, bindForm);
  }

  window.A24NewsletterSignup = {
    init: init
  };

  init(document);

  ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      init(event && event.target ? event.target : document);
    });
  });
}());
